import { CommonEntities, SystemAttribute } from "ui-ionic-comp";

export interface OrganizationUser {
  id: string;
  userId: string;
  orgaId: string;
  roleId: number;

  // Navigation attributes
  role?: SystemAttribute;
}

export type OrganizationUsersResponse = CommonEntities<OrganizationUser>;

export enum OrganizationUserRoles {
  Admin = 'ORGA_ROLES_ADMIN'
}
